import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withTheme, MuiThemeProvider } from '@material-ui/core';
import { ContainerLayout, SubMenu } from 'data/components';
import { Toastr } from 'data/common';
import uiTheme from 'data/common/uiTheme';
import SubMenuData from '../common/subMenuData';
import { initEnvironment } from '../actions';

class Layout extends PureComponent {
    static propTypes = {
        initEnvironment: PropTypes.func.isRequired,
        children: PropTypes.object.isRequired,
        environment: PropTypes.string.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    static childContextTypes = {
        changeLoggingTheme: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null,
            theme: uiTheme('logging')
        };
    }

    getChildContext() {
        return { changeLoggingTheme: this.changeLoggingTheme };
    }

    componentDidMount() {
        const { profile, history } = this.props;
        if (!profile.get('admin') && !(profile.get('environments') && profile.get('environments').indexOf('logging') !== -1)) {
            Toastr.error(Translator.translate('error.message.envForbidden'));
            return history.replace('/menu');
        }
        this.initEnv();
    }

    changeLoggingTheme = otherTheme => {
        const { theme } = this.state;

        if (theme.id !== otherTheme.id) {
            this.setState({
                theme: otherTheme
            });
        }
    };

    initEnv = () => {
        const { initEnvironment } = this.props;
        this.setState({ loading: true, error: null });

        initEnvironment()
            .then(() => {
                this.setState({ loading: false, error: null });
            })
            .catch(err => {
                this.setState({ error: Translator.translateWithFallback(`api.message.${err.message}`, 'api.message.default'), loading: false });
            });
    };

    render() {
        const { loading, error, theme } = this.state;
        const { children, environment, profile } = this.props;
        const userRights = profile.getIn(['user_rights', environment], []);
        let tabList = {};
        if (!profile.get('admin') && userRights) {
            tabList = SubMenuData.filter(k => {
                return userRights.indexOf(k.right) !== -1;
            });
        } else {
            tabList = SubMenuData;
        }

        return (
            <MuiThemeProvider theme={theme}>
                <div className="d-flex flex-fill flex-column">
                    <SubMenu environment={environment} tabList={tabList} />
                    <ContainerLayout loading={loading} error={error} onClickFunc={this.initEnv}>
                        {children}
                    </ContainerLayout>
                </div>
            </MuiThemeProvider>
        );
    }
}

function mapStateToProps(state) {
    return {
        profile: state.data.user
    };
}

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators(Object.assign({}, { initEnvironment }), dispatch)
    )(withTheme(Layout))
);



// WEBPACK FOOTER //
// ./environments/logging/layouts/index.js